<template>
  <transition name="slide_extendedsidebar">
    <div v-show="active" class="ExtendedSidebar">
      <Listenansicht v-if="layer === 'Listenansicht'" @close="handleCloseSidebar"/>
      <Partneransicht v-if="layer === 'Partneransicht'" @close="handleCloseSidebar"/>
      <Impressum v-if="layer === 'Impressum'" @close="handleCloseSidebar"/>
      <Datenschutz v-if="layer === 'Datenschutz'" @close="handleCloseSidebar"/>
      <Profil v-show="layer === 'Profil'" @close="handleCloseSidebar"/>
      <ETankstellenFilter v-if="layer === 'ETankstellenFilter'" @close="handleCloseSidebar"/>
      <FAQ v-if="layer === 'FAQ'" @close="handleCloseSidebar"/>
    </div>
  </transition>
</template>

<script>
import Datenschutz from "./Datenschutz.vue";
import Impressum from "./Impressum.vue";
import Listenansicht from "./Listenansicht.vue";
import Partneransicht from "./Partneransicht.vue";
import Profil from "./Profil.vue";
import ETankstellenFilter from "./ETankstellenFilter.vue";
import FAQ from "./FAQ.vue";

export default {
  name: "ExtendedSidebar",
  components: {
    Datenschutz,
    Impressum,
    Listenansicht,
    Partneransicht,
    Profil,
    ETankstellenFilter,
    FAQ
  },
  methods: {
    handleCloseSidebar() {
      this.$store.commit("setExtendedSidebarActiveFalse");
    }
  },
  computed: {
    active() {
      return this.$store.state.ExtendedSidebarActive;
    },
    layer() {
      return this.$store.state.ExtendedSidebarActiveLayer;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ExtendedSidebar {
  width: 450px;
  height: 100%;
  background-color: white;
  position: relative;
  z-index: 1003;
  padding: 0 15px 0 30px;
  overflow-y: auto;
}
@media (max-width: 768px) {
  .ExtendedSidebar {
    width: 100vw;
    position: absolute;
    left: 0;
    padding: 0 15px;
  }
}

/* SMALL MENU BUTTON IN ANIMATION*/
.slide_extendedsidebar-enter,
.slide_extendedsidebar-leave-to {
  width: 0px;
}
.slide_extendedsidebar-leave,
.slide_extendedsidebar-enter-to {
  width: 450px;
}
@media (max-width: 768px) {
  .slide_extendedsidebar-leave,
  .slide_extendedsidebar-enter-to {
    width: 100vw;
  }
}
.slide_extendedsidebar-enter-active,
.slide_extendedsidebar-leave-active {
  transition: width 0.5s;
}
</style>
